import { render } from "./PayoutDetails.vue?vue&type=template&id=f1756b84&ts=true"
import script from "./PayoutDetails.vue?vue&type=script&lang=ts"
export * from "./PayoutDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__